import { afterNextRender, ChangeDetectionStrategy, Component, DestroyRef, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-label',
  imports: [],
  templateUrl: './label.component.html',
  styleUrl: './label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LabelComponent {
  readonly control = input.required<FormControl>();
  readonly conditionControl = input<FormControl | null>(null);

  readonly isOk = signal<boolean>(false);

  constructor() {
    const destroyRef = inject(DestroyRef);
    afterNextRender(() => {
      const control = this.control();
      const conditionControl = this.conditionControl();

      this.isOk.set(control.valid && (conditionControl === null || conditionControl.valid));

      this.control().valueChanges
        .pipe(takeUntilDestroyed(destroyRef))
        .subscribe(() => {
          this.isOk.set(control.valid && (conditionControl === null || conditionControl.valid));
        });

      if (conditionControl !== null) {
        conditionControl.valueChanges
          .pipe(takeUntilDestroyed(destroyRef))
          .subscribe(() => {
            this.isOk.set(control.valid && (conditionControl === null || conditionControl.valid));
          });
      }
    });

  }
}
